import { updatePartner360Configuration } from 'legacy/lut/services/partner360/configuration/updatePartner360Configuration'
import { map621ToShareOfBusiness } from 'legacy/lut/services/partner360/shareOfBusiness/mappings/map621ToShareOfBusiness'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { selectFinancialYear } from '../../configuration'
import { selectPartner360Data, transformPercentToFloat } from '../../configuration'
import { REQUEST_PARTNER360_UPDATE_TOP_VENDOR_BRANDS } from '../constants'
import { IPartnerTopVendorBrandsForm, IShareOfBusiness } from '../models'

export const requestUpdateTopVendorBrands = createAsyncThunk<
  IShareOfBusiness,
  IPartnerTopVendorBrandsForm
>(REQUEST_PARTNER360_UPDATE_TOP_VENDOR_BRANDS, async (form, { getState }) => {
  const state = getState()
  const configuration = selectPartner360Data(state)
  const fYear = selectFinancialYear(state)

  const updatedData = await updatePartner360Configuration({
    EntryId: configuration.entryId,
    PartnerId: configuration.partnerId,
    FYear: fYear,

    A3TopVendorBrand1: form.a3TopVendorBrand1,
    A3TopVendorBrand1Spend: transformPercentToFloat(form.a3TopVendorBrand1Spend),
    A3TopVendorBrand2: form.a3TopVendorBrand2,
    A3TopVendorBrand2Spend: transformPercentToFloat(form.a3TopVendorBrand2Spend),
    A3TopVendorBrand3: form.a3TopVendorBrand3,
    A3TopVendorBrand3Spend: transformPercentToFloat(form.a3TopVendorBrand3Spend),
    A3TopVendorBrandOtherSpend: transformPercentToFloat(form.a3TopVendorBrandOtherSpend),

    A4TopVendorBrand1: form.a4TopVendorBrand1,
    A4TopVendorBrand1Spend: transformPercentToFloat(form.a4TopVendorBrand1Spend),
    A4TopVendorBrand2: form.a4TopVendorBrand2,
    A4TopVendorBrand2Spend: transformPercentToFloat(form.a4TopVendorBrand2Spend),
    A4TopVendorBrand3: form.a4TopVendorBrand3,
    A4TopVendorBrand3Spend: transformPercentToFloat(form.a4TopVendorBrand3Spend),
    A4TopVendorBrandOtherSpend: transformPercentToFloat(form.a4TopVendorBrandOtherSpend),
  })

  return map621ToShareOfBusiness(updatedData)
})
